import type { z } from 'zod';
import { CandidateSchema } from '@axiom/validation';

export const ProfileHeaderDisplayNameSchema = CandidateSchema.pick({
  displayFirstName: true,
  displayLastName: true,
  pronouns: true,
});

export type ProfileHeaderDisplayName = z.infer<
  typeof ProfileHeaderDisplayNameSchema
>;
